import { TextInput } from '@mgmresorts/mgm-ui';
import React, { useContext, useMemo } from 'react';

import { useContent } from '../../../hooks/useContent';
import { MaxLengths } from '../../../utils/constants';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

export function LastName() {
  const { bindLastName, isLoading, invalidFields } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  useFieldErrorAnalytics({ field: 'lastName', invalidFields });

  const error = useMemo(
    (): string | undefined =>
      invalidFields.includes('lastName') ? getContentByPath('accountCreation.fields.lastName.error') : undefined,
    [getContentByPath, invalidFields],
  );

  return (
    <TextInput
      variant='default'
      label={getContentByPath('accountCreation.fields.lastName.title')}
      id='lastName'
      testId='lastName'
      disabled={isLoading}
      error={!!error}
      hint={error}
      {...bindLastName}
      maxLength={MaxLengths.LastName}
      autoComplete='family-name'
    />
  );
}

LastName.displayName = 'LastNameField';
